import React from 'react';
import styles from '../styles/CardsApp.module.css';
import { FaMoneyBillWave, FaShieldAlt, FaTruck, FaRegCheckSquare } from 'react-icons/fa';

const CardsApp = () => {
  return (
    <div className={styles.cardsContainer}  style={{ maxWidth: 'none' }}>
      <div className={styles.cards}>
        <div className={styles.card}>
          <div>
            <FaMoneyBillWave className={styles.icon} />   
          </div>
          <div className={styles.text_card}>
            <h3>PAGAMENTO</h3>
            <p>5% de desconto à vista.</p>
          </div>
        </div>
        <div className={styles.card}>
          <div>
            <FaShieldAlt className={styles.icon} />     
          </div>
          <div className={styles.text_card}>
            <h3>SEGURANÇA</h3>
            <p>Empresa com mais de 50 anos de tradição.</p>
          </div>
        </div>
        <div className={styles.card}>
          <div>
            <FaTruck className={styles.icon} />
          </div>
          <div className={styles.text_card}>
            <h3>ENTREGA</h3>
            <p>Retirada no local ou via transportadora.</p>
          </div>
        </div>
       
        
      </div>
    </div>
  );
};

export default CardsApp;